import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'laFilterOutSpecial' })
export class FilterOutSpecialPipe implements PipeTransform {
  transform(list: string[], special: string): string[] {
    return list.filter((item) => item !== special);
  }
}
